(() => {
  const media = window.matchMedia('(max-width: 767px)');
  function initialize(root = document) {
    root.querySelectorAll('[data-marturi-footer-toggle]:not([data-mf-ready])').forEach(button => {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      const column = button.closest('.t4s-col-inner');
      const collapsible = button.closest('.is--footer-collapse-true');
      if (!panel || !column) return;
      button.dataset.mfReady = '';
      const setOpen = open => {
        panel.hidden = !open;
        button.setAttribute('aria-expanded', String(open));
        column.classList.toggle('is--footer_opened', open);
      };
      const adapt = () => {
        const active = media.matches && !!collapsible;
        button.disabled = !active;
        if (!active || !panel.contains(document.activeElement)) setOpen(!active);
      };
      button.addEventListener('click', () => setOpen(button.getAttribute('aria-expanded') !== 'true'));
      media.addEventListener('change', adapt);
      adapt();
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
